export var source = "fragment Cart on Cart {\n  subscription {\n    ...Subscription\n  }\n  products {\n    ...Products\n  }\n  giftCard {\n    ...GiftCard\n  }\n  giftSubscription {\n    ...GiftSubscription\n  }\n  shipping {\n    ...Shipping\n  }\n  total\n}";
import { source as fragment1 } from "./giftCard.graphql";
import { source as fragment2 } from "./giftRecipient.graphql";
import { source as fragment3 } from "./giftSubscription.graphql";
import { source as fragment4 } from "./product.graphql";
import { source as fragment5 } from "./products.graphql";
import { source as fragment6 } from "./shipping.graphql";
import { source as fragment7 } from "./subscription.graphql";
import { source as fragment8 } from "./subscriptionPlan.graphql";
var combined = source  + "\n" + fragment1 + "\n" + fragment2 + "\n" + fragment3 + "\n" + fragment4 + "\n" + fragment5 + "\n" + fragment6 + "\n" + fragment7 + "\n" + fragment8;
export default combined;